import * as actions from '../../actions/actions'

const initialState = {
  campaignDetail: {
    idLogo: '',
    campaignName: '',
    campaignLogo: '',
    enabled: false,
    bankId:''
  },
  error: ''
}

export default function campaignDetail(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_CAMPAIGN_DETAIL_SUCCESS:
      return fetchCampaignDetailSuccess(state, action)
    case actions.FETCH_CAMPAIGN_DETAIL_FAILURE:
      return fetchCampaignDetailFailure(state, action)
    case actions.DETAIL_CAMPAIGN_CLEAN:
      return detailCampaignClean(state, action)
    default:
      return state
  }
}

const fetchCampaignDetailSuccess = (state, action) => {
  return {
    ...state,
    campaignDetail: action.value
  }
}

const fetchCampaignDetailFailure = (state, action) => {
  return {
    ...state,
    error: action.error
  }
}


const detailCampaignClean = (state, action) => {
  return initialState;
}